setTimeout(() => {
  const selectElement = document.getElementsByClassName("single-option-selector");
  selectElement[0].addEventListener("change", (event) => {
  
      var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-variant-id");
      setTimeout(() => {
          var variantId = document.querySelector('[name="id"]').value;
          document.getElementsByClassName("axt-cp-custom")[0].classList.add(variantId);
          document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldVariant);
          document.getElementsByClassName("axt-cp-custom")[0].setAttribute("axt-cp-variant-id", variantId);
      }, "700");
  });
}, "1200");